/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";

import {
  Menu,
  MenuItem,
  IconButton,
  InputBase,
  styled,
  alpha,
} from "@mui/material";
import {
  AccountCircleOutlined as AccountIcon,
  Logout as LogoutIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { useThemeColors } from "../Context/Theme";
import cart from "../Images/ic-cart.png";
import profile from "../Images/ic-user.png";
import "./CSS/navbar.css";
import { useAutocomplete } from "@mui/base/useAutocomplete";
import CustomButton from "./CustomButton";
import {
  FADE_BLACK,
  GRAY_DARK,
  PRIMARY,
  SEARCH_BACKGROUND,
  SEARCH_BORDER,
  SEARCH_COLOR,
  WHITE,
} from "../styles/color";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { red } from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../Features/services/cartSlice";
import API_URL from "../ServiceModule/Service";
import axios from "axios";
import { useGetAPIQuery, useGetAPIWithoutTokenQuery, usePostAPIWithOutTokenMutation, usePostNotificationAPIWithOutTokenMutation, useGetNotificationAPIQuery, usePostNotificationAPIWithTokenMutation } from "../Api/api";
import Avatar from "@mui/material/Avatar";
import orderThatIcon from "../Images/orderThatIcon.png";
import NotificationIcon from "../Images/ic-notification-black.png";
import { READ_ALL_NOTIFICATION, UPDATE_NOTIFICATION, READ_ONE_USER } from "../Api/apiConstant";
import { toast, ToastContainer } from "react-toastify";
import { skipToken } from '@reduxjs/toolkit/query/react';
import { getLoggedIn, getToken, getUserId, getUserLogin, removeAllCookies, removeUserLogin } from "../LoginModule/LoginUtility";
import { setNotificationTotalCount }  from "../Features/message/messageSlice";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius + 8,
  backgroundColor: WHITE,
  border: `0.6px solid ${SEARCH_BORDER}`,
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(3),
  width: "auto",
  "&:hover": {
    backgroundColor: alpha(SEARCH_BACKGROUND, 0.25),
  },
}));
const SearchIconWrapper = styled("div")({
  height: "100%",
  width: "10%",
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
});
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: SEARCH_COLOR,
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    width: "35ch",
    fontFamily: "Poppins",
  },
  "& .MuiInputBase-input::placeholder": {
    color: "black",
    opacity: 1,
  },
}));
const Listbox = styled("ul")(({ theme }) => ({
  width: 410,
  margin: 0,
  padding: 0,
  position: "absolute",
  listStyle: "none",
  borderRadius: "10px",
  maxHeight: 200,
  overflow: "auto",
  zIndex: 1,
  backgroundColor: "#fff",
  border: "1px solid rgba(0,0,0,.25)",
  "& li": {
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  "& li.Mui-focused, & li.selected": {
    backgroundColor: "#4a8df6",
    color: "white",
  },
}));
function Navbar({ className, eventName, isAtAllEvents }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const loggedIn = getLoggedIn() === "true";
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [anchorElPop, setAnchorElPop] = React.useState(null);
  const [anchorElToggle, setAnchorElToggle] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const cartId = sessionStorage.getItem("cartId");
  const seachParms = new URLSearchParams(location.search)
  const seachQuery = seachParms.get("search")
  const [searchInput, setSearchInput] = React.useState(seachQuery || '');
  const userId = getUserId()
  const token = getToken()
  const eventId = sessionStorage.getItem("event_id");
  const dispatch = useDispatch();
  const [isListboxOpen, setIsListboxOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [notifcaionCount, setNotificationCount] = useState(0);
  const [updateIsReadNotification] = usePostNotificationAPIWithTokenMutation();
  const shouldCallnotifcationAPI = userId != null && eventId != null;
  const shouldCallproductAPI = eventId != null;
  const shouldCallUserAPI = userId != null && eventId != null;
  const [isBackspacePressed, setIsBackspacePressed] = useState(false);
  const isLoggedIn = getLoggedIn() === "true";
  const [openDialog, setOpenDialog] = useState(false);

  const { data: notifcation, isLoading } = useGetNotificationAPIQuery(
    isLoggedIn
      ? {
        url: `${READ_ALL_NOTIFICATION}?user_id=${userId}&event_id=${0}`,
        token: token,
      }
      : skipToken,
    { refetchOnMountOrArgChange: true });

    const notificationCount = useSelector(state => state.message.count);

  useEffect(() => {
  }, [notificationCount])

  useEffect(() => {
    if (!isLoading && notifcation && notifcation.data) {
      const unreadCount = notifcation.data.filter(notification => !notification.is_read).length;
      if (window.location.pathname.includes("notification")) {
        return;
      }
      setNotificationCount(unreadCount);
      dispatch(setNotificationTotalCount(unreadCount));
    }
  }, [isLoading, notifcation, dispatch]);

  useEffect(() => {
    if (!seachQuery) {
      setSearchInput('');
    }
  }, [seachQuery]);

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchInput('');

    const url = new URL(window.location);
    url.searchParams.delete('search');
    window.history.pushState({}, '', url);
  };

  useEffect(() => {
    if (location.state?.productName) {
      setSearchInput(location.state.productName);
    }
  }, [location]);
  const [debouncedSearch, setDebouncedSearch] = useState(searchInput);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchInput]);

  const handleSearch = (searchValue) => {
    const matchingOption = groupedOptions.find(
      (option) =>
        option.product_name.toLowerCase() === searchValue.toLowerCase() ||
        option.brands[0].brand_name
          .toLowerCase()
          .includes(searchInput.toLowerCase()) ||
        option.categories[0].category_name
          .toLowerCase()
          .includes(searchInput.toLowerCase()) ||
        option.product_description
          .toLowerCase()
          .includes(searchInput.toLowerCase())
    );

    if (matchingOption) {
      handleOptionClick(matchingOption);
    } else {

    }
  };
  const eventNameData = eventName
    ? eventName
    : sessionStorage.getItem("eventName");
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    linkColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
  } = useThemeColors();

  const {
    data,
    isLoading: productLoadinfg,
    isError: productError,
    error,
  } = useGetAPIWithoutTokenQuery(
    shouldCallproductAPI ? `${API_URL}/api/product/readAllProducts?event_id=${eventId}&page=${1}&limit=${1200000000000}&search=${debouncedSearch}` : skipToken
  );
  const { data: userData, isSuccess: userSuccess } = useGetAPIQuery(
    {
      url: `${READ_ONE_USER}user_id=${userId}`,
      token
    }
    , { skip: !userId }
  );

  useEffect(() => {
    if (!userData) return;

    const userLogin = getUserLogin();
    if (userLogin !== "true") return;

    const missingFields = [];
    if (!userData.user_name) missingFields.push("Name");
    if (!userData.user_email) missingFields.push("Email");
    if (!userData.phone_number) missingFields.push("Phone Number");
    if (!userData.zip_code) missingFields.push("Zip Code");

    if (missingFields.length > 0) {
      const formattedFields =
        missingFields.length === 1
          ? missingFields[0]
          : `${missingFields.slice(0, -1).join(", ")} and ${missingFields.slice(-1)}`;

      toast.error(
        `Your ${formattedFields} ${missingFields.length > 1 ? "are" : "is"} not filled. Please fill ${missingFields.length > 1 ? "them" : "it"
        } in your profile for better experience.`,
        { autoClose: 1000 }, { containerId: "child" }
      );
      removeUserLogin();
    }
  }, [userData]);


  function getInitials(firstName, lastName) {
    if (firstName && lastName) {
      const initials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
      return initials;
    } else if (firstName) {
      return firstName.charAt(0).toUpperCase();
    } else if (lastName) {
      return lastName.charAt(0).toUpperCase();
    }
    return '';
  }




  const determineActivePage = () => {
    if (location.pathname.includes("/shop")) return "shop";
    if (location.pathname.includes("/shop")) return "shop";
    if (location.pathname.includes("/cart")) return "cart";
    if (location.pathname.includes("/contact")) return "contact";
    if (location.pathname.includes("/profile")) return "profile";


    if (location.pathname === "/") return "/";
    return "home";
  };

  const activePage = determineActivePage();
  const filteredOptions = data?.data?.filter(
    (option) =>
      option.product_name.toLowerCase().includes(searchInput.toLowerCase()) ||
      option.brands[0].brand_name
        .toLowerCase()
        .includes(searchInput.toLowerCase()) ||
      option.categories[0].category_name
        .toLowerCase()
        .includes(searchInput.toLowerCase()) ||
      option.product_description
        .toLowerCase()
        .includes(searchInput.toLowerCase())

  );

  const {
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    setValue,
    inputValue,
  } = useAutocomplete({
    id: "use-autocomplete-demo",
    options: filteredOptions || [],
    getOptionLabel: (option) => option?.product_name || option?.brands[0].brand_name || option?.categories[0].category_name || option?.product_description || "",
    filterOptions: (options, { inputValue }) =>
      options.filter((option) =>
        option?.product_name.toLowerCase().includes(inputValue.toLowerCase()) ||
        option?.brands[0].brand_name
          .toLowerCase()
          .includes(searchInput.toLowerCase()) ||
        option?.categories[0].category_name
          .toLowerCase()
          .includes(searchInput.toLowerCase()) ||
        option?.product_description
          .toLowerCase()
          .includes(searchInput.toLowerCase())

      ),
  });

  const listboxProps = getListboxProps();
  const handleClick = (event) => {
    navigate(`/events/${eventNameData}/cart`);
  };

  const open = Boolean(anchorElPop);
  const id = open ? "simple-popover" : undefined;

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const cartItems = useSelector((state) => state?.cart?.items);
  const bundle = useSelector((state) => state?.cart?.bundle);
  const totalQuantity = useSelector((state) => state?.cart?.totalQuantity);

  function handleHome() {
    navigate(`/events/${eventNameData}`);
  }

  function handleShop() {
    navigate(`/events/${eventNameData}/shop`, { state: { category: "all" } });
  }

  function handleAllEvents() {
    if (location.pathname === "/events") {
      window.scrollTo(0, 0);
    } else {
      navigate(`/events/`);
    }
  }

  function handleAbout() {
    if (isAtAllEvents) {
      navigate(`/events/contact`, { state: { isAtAllEvents: isAtAllEvents } });
    } else {
      navigate(`/events/${eventNameData}/contact`);
    }
  }

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
    if (window.innerWidth < 1260) setShowMenu(false);
  };


  const handleUpdateNotification = async (notificationIds) => {

    // Create payload as JSON
    const payload = Array.isArray(notificationIds)
      ? { notification_id: notificationIds, is_read: true }
      : { notification_id: notificationIds, is_read: true };

    try {
      const response = await updateIsReadNotification({
        url: UPDATE_NOTIFICATION,
        formData: payload,
        token: token,
      })

 // Update the notification count in the Redux store
 const unreadCount = notifcation.data.filter(notification => !notification.is_read).length;
 dispatch(setNotificationTotalCount(unreadCount));

    } catch (error) {

    }
  };


  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setAnchorEl(null);
    });
  }, []);

  const handleMenuClick = (event) => {
    setShowMenu(!showMenu);
    setAnchorElToggle(!showMenu);
  };

  const handleNavigation = (route) => {
    navigate(route);
  };

  function handleSignOut() {
    setOpenDialog(true);
  }

  function handleLogout() {
    dispatch(clearCart());
    localStorage.removeItem("loggedIn");
    localStorage.removeItem("token");
    localStorage.removeItem("user_Id");
    localStorage.removeItem("email");
    sessionStorage.removeItem("cartId");
    removeAllCookies()
    navigate(`/events/${eventNameData}`);
    window.location.reload();
  };

  const handleCloseToggle = () => {
    setAnchorElToggle(null);
    setShowMenu(false);
  };

  const handleLogin = () => {
    navigate(`/events/${eventNameData}/login`);
  };
  const handleProfile = () => {
    navigate(`/events/${eventNameData}/profile`);
  };
  const handleCart = () => {
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    navigate(`/events/${eventNameData}/cart`);
  };

  const handleNotification = () => {
    navigate(`/events/${eventNameData}/notification`);
  };

  const handleInputChange = (e) => {
    setSearchInput(e.target.value.trimStart());
    setIsListboxOpen(e.target.value.length > 0);
    // if (e.target.value.length <= 0) {

    //   navigate(`/events/${eventNameData}/shop`, { state: { category: "all" } });
    // }
    if (e.target.value.length <= 0 && location.pathname.includes("/shop")) {
      navigate(`/events/${eventNameData}/shop`, { state: { category: "all" } });
    }
  };

  const handleKeyDown = (e) => {

    if (e.key === "ArrowDown") {
      setSelectedIndex((prevIndex) =>
        Math.min(prevIndex + 1, groupedOptions.length - 1)
      );
      setIsListboxOpen(true);
    } else if (e.key === "ArrowUp") {
      setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
      setIsListboxOpen(true);
    } else if (e.key === "Enter" && searchInput.length >= 3) {
      handleOptionClick({ product_name: searchInput }, "enter");
    } else if (e.key === "Enter" && searchInput.length < 3) {

    }
  };



  const handleEnterKeyPress = () => {
    if (groupedOptions.length > 0 && selectedIndex >= 0) {
      const selectedOption = groupedOptions[selectedIndex];
      handleOptionClick(selectedOption);
    } else if (searchInput.trim() !== "") {
      const matchingOption = filteredOptions.find(
        (option) =>
          option.product_name.toLowerCase() === searchInput.toLowerCase() ||
          option.brands[0].brand_name.toLowerCase() === searchInput.toLowerCase() ||
          option.categories[0].category_name.toLowerCase() === searchInput.toLowerCase() ||
          option.product_description.toLowerCase() === searchInput.toLowerCase()

      );

      if (matchingOption) {
        handleOptionClick(matchingOption);
      } else {

        setIsListboxOpen(true);
      }
    } else {


      setIsListboxOpen(true);
    }
  };

  const handleOptionClick = (option, type = 'enter') => {

    if (option !== undefined) {
      setSearchInput(option.product_name);
      setIsListboxOpen(false);
      navigate(`/events/${eventNameData}/shop?search=${searchInput}`, {
        state: { results: type == 'enter' ? filteredOptions : [option], category: "searchResults" }
      });
    }
  };

  return (
    <>
      <ToastContainer containerId="child" />
      <nav
        className={className}
        style={{
          padding: "0 40px",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 3px 3px -3px",
          position: "fixed",
          top: 0,
          zIndex: 1000,
          backgroundColor: "#fff",
          width: "100%",
        }}
      >
        <div className="nav-style d-flex justify-content-between align-items-center py-3">

          <img
            src={isAtAllEvents ? orderThatIcon : logo}
            alt="Logo"
            width={150}
            style={{ cursor: "pointer" }}
            onClick={() => handleNavigation(isAtAllEvents ? `/events/` : `/events/${eventNameData}`)}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "100%",

            }}
          >
            {windowWidth >= 726 && (
              !isAtAllEvents && <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  {...getInputProps()}
                  value={searchInput}
                  placeholder="Search for products..."
                  onKeyDown={handleKeyDown}
                  onChange={handleInputChange}
                  onFocus={() => setIsListboxOpen(true)}
                  onBlur={() => setTimeout(() => setIsListboxOpen(false), 150)}
                  style={{ fontFamily, fontSize, fontWeight }}
                />
                {isListboxOpen && searchInput && (
                  <Listbox {...getListboxProps()}>
                    {filteredOptions?.filter(product => !product?.skus?.every(sku => sku?.sku_status === 0))?.length > 0 ? (
                      filteredOptions?.filter(product => !product?.skus?.every(sku => sku?.sku_status === 0))?.map((option, index) => (
                        <li
                          {...getOptionProps({
                            option,
                            index: option.product_id,
                          })}
                          key={option.product_id}
                          onClick={() => handleOptionClick(option, "onclick")}
                          className={selectedIndex === index ? "selected" : ""}
                          style={{ fontFamily, fontSize, fontWeight }}
                        >
                          <span>{option.product_name}</span>
                        </li>
                      ))
                    ) : (
                      <li style={{ fontFamily, fontSize, fontWeight }}>No results found</li>
                    )}
                  </Listbox>
                )}
              </Search>
            )}

            {windowWidth < 1260 ? (
              <>
                <IconButton onClick={handleMenuClick}>
                  {showMenu ? <CloseIcon /> : <MenuIcon />}
                </IconButton>
                <Menu
                  anchorEl={anchorElToggle}
                  open={Boolean(anchorElToggle)}
                  onClose={handleCloseToggle}

                  PaperProps={{
                    className: 'custom-menu',
                    style: {
                      left: 'unset',
                    },

                  }}
                >
                  {!isAtAllEvents && <> <MenuItem
                    onClick={() => {
                      handleHome();
                      handleCloseToggle();
                    }}
                    selected={activePage === "home"}
                    style={{ fontFamily, fontSize, fontWeight }}
                  >
                    Home
                  </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleShop();
                        handleCloseToggle();
                      }}
                      selected={activePage === "shop"}
                      style={{ fontFamily, fontSize, fontWeight }}
                    >
                      Shop
                    </MenuItem></>}
                  <MenuItem
                    onClick={() => {
                      handleAbout();
                      handleCloseToggle();
                    }}
                    selected={activePage === "contact"}
                    style={{ fontFamily, fontSize, fontWeight }}
                  >
                    Contact Us
                  </MenuItem>
                  {!isAtAllEvents && <MenuItem
                    onClick={() => {
                      handleCart();
                      handleCloseToggle();
                    }}
                    selected={activePage === "cart"}
                    style={{ fontFamily, fontSize, fontWeight }}
                  >
                    Cart
                  </MenuItem>}
                  <MenuItem
                    onClick={() => {
                      handleAllEvents();
                      handleCloseToggle();
                    }}
                    selected={activePage === "allEvents"}
                    style={{ fontFamily, fontSize, fontWeight }}
                  >
                    All Events
                  </MenuItem>
                  {!loggedIn && <MenuItem onClick={handleLogin}
                    style={{ fontFamily, fontSize, fontWeight }}
                  >
                    Login
                  </MenuItem>}
                  {loggedIn && (
                    <MenuItem
                      onClick={() => {
                        handleProfile();
                        handleCloseToggle();
                      }}
                      selected={activePage === "profile"}
                      style={{ fontFamily, fontSize, fontWeight }}
                    >
                      Profile
                    </MenuItem>
                  )}
                </Menu>
              </>
            ) : (
              <div
                className={`grid gap-4 d-flex align-items-center ${showMenu ? "show-menu" : "hide-menu"
                  }`}
                style={{
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                {!isAtAllEvents && <><div
                  className={`text-style nav-item ${activePage === "home" ? "active" : ""
                    }`}
                  onClick={() => handleHome()}
                  style={{
                    color: activePage === "home" ? primaryColor : FADE_BLACK,
                    fontFamily,
                    fontSize,
                    fontWeight
                  }}
                >
                  Home
                </div>
                  <div
                    className={`text-style ${activePage === "shop" ? "active" : ""
                      }`}
                    onClick={() => handleShop()}
                    style={{
                      color: activePage === "shop" ? primaryColor : FADE_BLACK,
                      fontFamily,
                      fontSize,
                      fontWeight
                    }}
                  >
                    Shop
                  </div>
                </>}
                <div
                  className={`text-style nav-item ${activePage === "contact" ? "active" : ""
                    }`}
                  onClick={() => handleAbout()}
                  style={{
                    fontSize: fontSize || "1.1rem",
                    color: activePage === "contact" ? primaryColor : FADE_BLACK,
                    fontFamily,
                    fontWeight
                  }}
                >
                  Contact Us
                </div>
                <div
                  className={`text-style ${activePage === "/" ? "active" : ""
                    }`}
                  style={{
                    color: activePage === "/" ? primaryColor : FADE_BLACK,
                  }}
                >
                  <CustomButton
                    text="All Events"
                    size="sm"
                    onClick={() => handleAllEvents()}
                    className="py-1 px-3"
                    borderRadius={"5px"}
                  />
                </div>
                {!isAtAllEvents && loggedIn ? (
                  <>
                    <div style={{ position: "relative", marginRight: "10px", cursor: "pointer" }} onClick={handleCart}>
                      <img
                        src={cart}
                        alt=""
                        style={{
                          cursor: "pointer",
                          color: "black",
                          height: "3vh",
                          width: "1.5vw",
                        }}
                      />
                      {totalQuantity > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            bottom: "1.5vh",
                            left: "1vw",
                            backgroundColor: primaryColor || PRIMARY,
                            height: "2.5vh",
                            width: "3.5vh",
                            borderRadius: "50%",
                            fontSize: fontSize || "0.8rem",
                            fontWeight: fontWeight || "bold",
                            color: "white",
                            zIndex: 100,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontFamily
                          }}
                        >
                          {totalQuantity}
                        </span>
                      )}
                    </div>
                    <div style={{ position: "relative", marginRight: "10px", cursor: "pointer" }} onClick={handleNotification}>
                      <img
                        src={NotificationIcon}
                        onClick={() => handleUpdateNotification(notifcation?.data.map(notification => notification.notification_id))}
                        alt=""
                        style={{
                          cursor: "pointer",
                          color: "black",
                          height: "4vh",
                          width: "2vw",
                        }}
                      />
                      {notifcaionCount > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            bottom: "1.5vh",
                            left: "1vw",
                            backgroundColor: primaryColor || PRIMARY,
                            height: "2.5vh",
                            width: "2.5vh",
                            borderRadius: "50%",
                            fontSize: fontSize || "0.8rem",
                            fontWeight: fontWeight || "bold",
                            color: "white",
                            zIndex: 100,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontFamily
                          }}
                          onClick={() => handleUpdateNotification(notifcation.data.map(notification => notification.notification_id))}

                        >
                          {notifcaionCount}
                        </span>
                      )}
                    </div>

                    <Avatar
                      sx={{
                        bgcolor: "red",
                        cursor: "pointer",
                        color: "white",
                        height: "5vh",
                        width: "2.5vw",
                        fontSize: fontSize || "1rem",
                        fontWeight: fontWeight || "600",
                        fontFamily
                      }}
                      onClick={handleOpenMenu}
                    >
                      {getInitials(userData?.first_name, userData?.last_name)}
                    </Avatar>
                    <Menu
                      style={{
                        marginTop: "70px",
                        zIndex: 1200,
                        "& .MuiPaper-root": {
                          borderRadius: "10px",
                        }
                      }}
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleCloseMenu}
                      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                      transformOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      MenuListProps={{
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          padding: "0",
                          margin: "0",
                          alignItems: "flex-start",
                          width: "100%",
                          fontFamily,
                          fontSize,
                          fontWeight
                        },
                      }}
                      BackdropProps={{ invisible: true }}
                      PaperProps={{
                        style: {
                          backgroundColor: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "10px",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        },
                      }}
                    >
                      <MenuItem
                        onClick={handleProfile}
                        style={{
                          padding: "8px 16px",
                          width: "100%",
                        }}
                      >
                        <AccountCircleOutlinedIcon />
                        <span
                          style={{
                            paddingLeft: "10px",
                            fontSize: fontSize || "16px",
                            fontFamily: fontFamily || "Poppins",
                            fontWeight
                          }}
                        >
                          My Profile
                        </span>
                      </MenuItem>
                      <MenuItem
                        onClick={handleSignOut}
                        style={{
                          padding: "8px 16px",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          fontFamily,
                          fontSize,
                          fontWeight
                        }}
                      >
                        <LogoutIcon />
                        <span
                          style={{
                            paddingLeft: "10px",
                            fontSize: "16px",
                            fontFamily: fontFamily || "Poppins",
                            fontSize,
                            fontWeight
                          }}
                        >
                          Logout
                        </span>
                      </MenuItem>
                    </Menu>
                  </>
                ) : (
                  !isAtAllEvents && <CustomButton
                    text="Login"
                    size="sm"
                    onClick={handleLogin}
                    className="py-1 px-3"
                    borderRadius={"5px"}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </nav>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg">
        <DialogTitle>Logout</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to logout?</Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", padding: "30px" }}>

          <CustomButton onClick={handleLogout}
            text="Yes"
            size="sm"
            block={true}
            className="btn-sm"
          />

          <CustomButton
            text="No"
            size="sm"
            block={true}
            className="btn-sm"
            bgcolor={"black"}
            onClick={() => setOpenDialog(false)}
          />

        </DialogActions>
      </Dialog>

    </>
  );
}
export default Navbar;
